import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import Service from './real-time-dashboard-analytics/service-detail';
import Video from './section-components/video-v3';
import FunFact from './section-components/funfact-v5';
import Pricing from './section-components/pricing-v2';
import Footer from './global-components/footer-v2';

const ServiceV1 = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Real-Time Dashboard & Analytics"  />
        <Service />
        <Video />
        {/*<FunFact />*/}
        {/*<Pricing />*/}
        {/*<Brand />*/}
        {/*<Testimonial />*/}
        <Footer />
    </div>
}

export default ServiceV1

